export default "__VITE_ASSET__CchEHCr3__$_?height=200&width=300__"